import { StaticImage } from 'gatsby-plugin-image'
import React, { useEffect, useState } from 'react'
import Layout from '../../../shared/components/organisms/layout/layout'
import SEO from '../../../shared/seo'
import useMediaQuery from '../../../utils/useMediaQuery'
import ModalViewer from '../../organisms/modal-viewer/modal-viewer'
import { title, description } from './../../../constants/activity-seo'
import previewImg from '../../../assets/images/preview.png'
import { siteUrl } from '../../../shared/utils/siteUrl'
import './page-layout.scss'

const initScrollBehavior = () => {
  if (typeof window !== 'undefined') {
    var lastScroll = 0
    document.addEventListener(
      'scroll',
      function () {
        var st = window.pageYOffset || document.body.scrollTop

        if (st > lastScroll) {
          document.body.classList.add('layout-deactive')
        } else {
          document.body.classList.remove('layout-deactive')
        }
        lastScroll = st
      },
      false
    )
  }
}
const PageLayout = ({ children }) => {
  const [fullPage, setFull] = useState(false)
  const isMobile = useMediaQuery()

  useEffect(() => {
    // ESPERAMOS 3.1 segundos para que el usuario tenga la experiencia inmediata correcta
    setTimeout(() => {
      setFull(true)
    }, 3100)
    initScrollBehavior()
  })
  const content = (
    <>
      <SEO
        title={title}
        description={description}
        image={siteUrl + previewImg}
      />
      <ModalViewer />
      <div className="f-page-layout__container">{children}</div>
    </>
  )
  if (!fullPage) {
    return (
      <>
        <header>
          <div className="logo-placeholder">
            <StaticImage
              src="../../../assets/images/logo_nosotras.svg"
              alt="Nosotras"
              className="logo"
              placeholder="blurred"
            />
          </div>
        </header>
        <main>{content}</main>
      </>
    )
  }
  return <Layout mobile={isMobile}>{content}</Layout>
}

export default PageLayout
